/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save({ attributes }) {
	const {
		title,
		accentColor,
		showInterest
	} = attributes;

	const blockProps = useBlockProps.save();

	return (
						<div { ...blockProps }>
			<div
				className="loan-calculator"
				style={{ '--accent-color': accentColor }}
				data-show-interest={showInterest}
			>
				<h3>{title}</h3>
				<form className="loan-calculator-form">
					<div className="loan-calculator-field">
						<label htmlFor="total-amount">Total Amount ($)</label>
						<input
							type="text"
							id="total-amount"
							name="total-amount"
							defaultValue="100,000"
							inputMode="numeric"
							required
						/>
					</div>
					<div className="loan-calculator-field">
						<label htmlFor="down-payment">Down Payment ($)</label>
						<input
							type="text"
							id="down-payment"
							name="down-payment"
							defaultValue="20,000"
							inputMode="numeric"
							required
						/>
					</div>
					<div className="loan-calculator-field">
						<label htmlFor="interest-rate">Interest Rate (%)</label>
						<input
							type="text"
							id="interest-rate"
							name="interest-rate"
							defaultValue="6.5"
							inputMode="decimal"
							required
						/>
					</div>
					<div className="loan-calculator-field">
						<label htmlFor="amortization-period">Amortization Period (Months)</label>
						<input
							type="text"
							id="amortization-period"
							name="amortization-period"
							defaultValue="72"
							inputMode="numeric"
							required
						/>
					</div>
					<div className="loan-calculator-results">
						<div className="monthly-payment">
							<strong>Monthly Payment: <span className="amount">$0.00</span></strong>
						</div>
						{showInterest && (
							<div className="total-interest">
								<strong>Total Interest: <span className="amount">$0.00</span></strong>
							</div>
						)}
					</div>
				</form>
			</div>
		</div>
	);
}
